import { render, staticRenderFns } from "./ProjectData.vue?vue&type=template&id=1ed54668&scoped=true"
import script from "./ProjectData.vue?vue&type=script&lang=js"
export * from "./ProjectData.vue?vue&type=script&lang=js"
import style0 from "./ProjectData.vue?vue&type=style&index=0&id=1ed54668&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ed54668",
  null
  
)

export default component.exports